import React, { useState, useEffect, useRef } from 'react';
import { FiDownload } from 'react-icons/fi';
import API from 'shared/api';
import { getLandingUrl } from 'shared/config';

function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const deferredRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      deferredRef.current = e;
      setDeferredPrompt(e);
      window.__agoraxDeferredPrompt = e;
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const instalarApp = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
      deferredRef.current = null;
    }
  };

  const irAlChat = () => {
    window.location.href = '/';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    try {
      const response = await API.post('/auth/login', {
        usuario: usuario,
        clave: clave,
      });

      console.log('Respuesta del servidor:', response.data);

      if (response.data.status === 'success') {
        const userData = response.data.usuario;
        localStorage.setItem('usuario', JSON.stringify(userData));
        if (userData.empresa_slug) {
          localStorage.setItem('agorax_empresa_slug', userData.empresa_slug);
        }
        if (onLogin) {
          onLogin(userData);
        }
      } else {
        setError('Credenciales incorrectas');
      }
    } catch (err) {
      console.error('Error detallado:', err);
      console.error('Respuesta del error:', err.response);
      setError(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 480px) {
          .login-card { padding: 24px 20px !important; max-width: 100% !important; margin: 0 12px; border-radius: 16px !important; }
          .login-title { font-size: 22px !important; }
          .login-subtitle { font-size: 13px !important; }
        }
      `}</style>
      <div className="login-card" style={styles.card}>
        <div style={styles.logoArea}>
          <img src="/logo-agorax.jpeg" alt="Agorax" style={styles.logoImg} />
        </div>
        <h1 className="login-title" style={styles.title}>
          Agorax
        </h1>
        <h2 className="login-subtitle" style={styles.subtitle}>
          Panel de Trabajadores
        </h2>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Usuario</label>
            <input
              type="text"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              style={styles.input}
              placeholder="Ingresa tu usuario"
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Contraseña</label>
            <input
              type="password"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              style={styles.input}
              placeholder="Ingresa tu contraseña"
              required
            />
          </div>

          <button type="submit" style={styles.button} disabled={cargando}>
            {cargando ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <button onClick={irAlChat} style={styles.chatLink}>
            Ir al chat de atención al cliente
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: '12px' }}>
          <button
            onClick={() => (window.location.href = getLandingUrl())}
            style={styles.registerLink}
          >
            Registra tu empresa
          </button>
        </div>

        {deferredPrompt && (
          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <button onClick={instalarApp} style={styles.installBtn}>
              <FiDownload size={16} />
              Instalar App
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: 'var(--agx-bg)',
  },
  card: {
    backgroundColor: 'var(--agx-surface)',
    padding: '40px',
    borderRadius: '24px',
    boxShadow: '0 4px 24px rgba(11,26,74,0.08)',
    width: '100%',
    maxWidth: '400px',
  },
  title: {
    textAlign: 'center',
    color: 'var(--agx-pri)',
    marginBottom: '4px',
    fontSize: '28px',
    fontWeight: 800,
    letterSpacing: '-0.5px',
  },
  subtitle: {
    textAlign: 'center',
    color: 'var(--agx-muted)',
    marginBottom: '30px',
    fontSize: '15px',
    fontWeight: 500,
  },
  form: { display: 'flex', flexDirection: 'column', gap: '18px' },
  inputGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: 600, color: 'var(--agx-pri)' },
  input: {
    padding: '12px 16px',
    border: '1.5px solid var(--agx-border)',
    borderRadius: '14px',
    fontSize: '15px',
    outline: 'none',
    fontFamily: 'inherit',
    backgroundColor: 'var(--agx-input-bg)',
    transition: 'border-color 0.2s',
    color: 'var(--agx-text)',
  },
  button: {
    padding: '14px',
    backgroundColor: 'var(--agx-pri2)',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '14px',
    fontSize: '15px',
    fontWeight: 700,
    cursor: 'pointer',
    marginTop: '6px',
    boxShadow: '0 4px 16px rgba(41,82,204,0.2)',
  },
  error: {
    backgroundColor: 'var(--agx-red-bg)',
    color: 'var(--agx-red)',
    padding: '10px',
    borderRadius: '12px',
    marginBottom: '20px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 500,
  },
  chatLink: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'var(--agx-pri2)',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: 'inherit',
  },
  registerLink: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'var(--agx-muted)',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: 'inherit',
    textDecoration: 'underline',
  },
  logoArea: { display: 'flex', justifyContent: 'center', marginBottom: '16px' },
  logo: {
    width: '64px',
    height: '64px',
    borderRadius: '16px',
    backgroundColor: 'var(--agx-pri)',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 800,
    letterSpacing: '-1px',
  },
  logoImg: { width: '64px', height: '64px', borderRadius: '16px', objectFit: 'contain' },
  installBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 24px',
    borderRadius: '14px',
    border: '1.5px solid var(--agx-pri)',
    backgroundColor: 'var(--agx-surface)',
    color: 'var(--agx-pri)',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'inherit',
  },
};

export default Login;
